import { css } from 'styled-components';

const styles = css`
  .resend-code-text {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-family: Nunito;
    text-align: ${(props) => (props.fromPlccICLogin ? 'left' : 'center')};
    .resent-code-cta {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      padding-left: 4px;
      color: ${(props) => props.theme.colorPalette.gray[900]};
    }
    button {
      background: none;
      border: none;
      cursor: pointer;
      text-decoration: underline;
      color: ${(props) => props.theme.colorPalette.blue.C900};
      outline: none;
    }
    .resend-it {
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      color: #003761;
    }
  }

  .otp-wrapper {
    margin: 0px 60px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: ${(props) =>
        props.isFromCheckout && props.isFromLoginCheckoutFlow
          ? '0px 38px 0px 46px'
          : '0px 35px 0 44px'};
    }
  }

  .parent-wrapper {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 28px 28px 60px;
    }
  }

  .otp-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      text-align: justify;
    }
  }
  .login-error {
    margin: ${(props) => props.isLoginWithOTPEnabled && '8px 0px 0px 5px;'};
  }

  .resent-code-link {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .otp-input-container {
    input {
      padding: 8px 3px;
    }
  }
  .create-account-otp-sub-heading {
    padding: 0px 20px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0px 10px;
    }
  }
  .underline {
    margin: 14px auto 36px auto;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 14px auto 28px auto;
    }
  }
  .create-account-otp-wrapper {
    width: 400px;
    margin: 0 auto 20px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-bottom: 12px;
      width: 350px;
    }
  }
  .create-acc-otp-button {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    margin-bottom: ${(props) => (props.isFromCheckout ? '12px' : '20px')};
    width: 396px;
    height: 45px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
      margin-bottom: 16px;
      width: 327px;
      height: 42px;
    }
  }
  .quad-brand-icon {
    margin: 12px 0px 32px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 20px 0px 10px;
    }
  }
  .otp-message {
    margin: 8px 50px;
    text-align: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 8px 24px;
    }
  }
  .rounded-corner {
    border-radius: 6px;
  }
  .different-email-link {
    color: ${(props) => props.theme.colorPalette.blue[200]};
    font-weight: bold;
  }
  .checkout-guest-button-container {
    display: flex;
    justify-content: center;
  }
  .checkout-guest-button {
    width: 396px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 327px;
    }
  }
  .otp-limit-message {
    margin-bottom: 24px;
    padding: 0 12px;
  }
  .recaptcha_loginotp {
    display: flex;
    justify-content: center;
  }
`;

export default styles;
